export type IListenerCallbackData = any;

export type IListenerCallback = (data?: IListenerCallbackData) => void;

export interface IListenerObject {
  context?: string; // useful for debugging which contexts auth came from
  callback: IListenerCallback;
}

export enum EVENT_SERVICE_EVENTS {
  UPDATED_MEDIA_PLAY_RESOURCE = 'updated-media-play-resource',
}
